<template>
    <div class="Field__Component">
        <div>
            <slot>{{ displayValue }}</slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FieldExerciseCategory',
    props: ['value', 'store'],
    created() {
        // Load categories if not already loaded
        if (this.storeInstance) {
            this.storeInstance.dispatch('exerciseCategories/loadCategories');
        }
    },
    computed: {
        storeInstance() {
            // Use the store prop if provided (for modal contexts),
            // otherwise fall back to global Vuex store
            return this.store || this.$store;
        },
        category() {
            if (!this.value || !this.storeInstance) return null;
            return this.storeInstance.getters['exerciseCategories/getCategoryById'](this.value);
        },
        isLoading() {
            if (!this.storeInstance) return false;
            return this.storeInstance.state.exerciseCategories.loading;
        },
        isLoaded() {
            if (!this.storeInstance) return false;
            return this.storeInstance.state.exerciseCategories.loaded;
        },
        displayValue() {
            if (!this.value) return '';
            
            // If categories are loaded, show category name or ID if not found
            if (this.isLoaded) {
                return this.category ? this.category.name : this.value;
            }
            
            // If still loading, show empty string (or you could show a loading indicator)
            // This prevents showing the ID number before categories are loaded
            return '';
        }
    },
    methods: {
        getExerciseCategory(categoryId) {
            if (!categoryId || !this.storeInstance) return null;
            return this.storeInstance.getters['exerciseCategories/getCategoryById'](categoryId);
        }
    }
}
</script>